import Vue from 'vue';
import moment from 'moment';
import i18n from '@/i18n.bootstrap';

export default {
    setUserData(state, userData) {
        Vue.set(state, 'loggedIn', userData.loggedIn);
        Vue.set(state, 'data', userData.data);
    },

    updateUserData(state, userData) {
        Vue.set(state.data, 'firstName', userData.firstName);
        Vue.set(state.data, 'lastName', userData.lastName);
        Vue.set(state.data, 'displayName', userData.displayName);
        Vue.set(state.data, 'email', userData.email);
        Vue.set(state.data, 'language', userData.language);
    },

    setLanguage(state, lang) {
        state.language = lang;
        moment.locale(lang);
        i18n.locale = lang;
    },

    resetStoreModuleData(state) {
        Vue.set(state, 'loggedIn', false);
        Vue.set(state, 'language', 'de');
        Vue.set(state, 'data', {});
    }
};
